import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type CreditAnalyticsParams } from '../types';
import META from './useTrackCreditMeterViewed.meta';

export type UseTrackCreditMeterViewedParams = CreditAnalyticsParams & {
  location: 'side_nav' | 'canvas' | 'dropdown_menu';
  trigger?: 'click' | 'hover';
};

export const useTrackCreditMeterViewed = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreditMeterViewed = useCallback(
    (params: UseTrackCreditMeterViewedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackCreditMeterViewed };
};
